import { useQuery } from 'react-query'

import { fetchUserChainAgency } from '@/api/agency/fetch-user-chain-agency'

export const useGetAgencyChain = () => {
  return useQuery({
    queryKey: ['agencyChain'],
    queryFn: fetchUserChainAgency,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
